exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-shared-LabeledField-label{margin-left:10px;word-wrap:break-word;white-space:pre-line}.src-components-shared-LabeledField-error{color:#dc3545;font-size:80%}", ""]);

// exports
exports.locals = {
	"label": "src-components-shared-LabeledField-label",
	"error": "src-components-shared-LabeledField-error"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/LabeledField/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/LabeledField/styles.scss
// module chunks = 1